import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import Icon from '../../../components/AppIcon';

const AnalyticsOverviewChart = ({ data, title, description }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-xs font-medium text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full" style={{ backgroundColor: entry?.color }}></div>
              <span className="text-xs text-muted-foreground">{entry?.name}:</span>
              <span className="text-xs font-semibold text-foreground">{entry?.value?.toLocaleString()}</span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-start justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">{title}</h3>
          <p className="text-xs md:text-sm text-muted-foreground">{description}</p>
        </div>
        <div className="p-2 rounded-lg bg-primary/10 text-primary">
          <Icon name="BarChart3" size={20} />
        </div>
      </div>

      <div className="w-full h-64 md:h-80" aria-label={`${title} Chart`}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorVisitors" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="rgb(37, 99, 235)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="rgb(37, 99, 235)" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorPageViews" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="rgb(245, 158, 11)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="rgb(245, 158, 11)" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="rgb(226, 232, 240)" opacity={0.5} />
            <XAxis 
              dataKey="date" 
              stroke="rgb(100, 116, 139)" 
              style={{ fontSize: '12px' }}
              tick={{ fill: 'rgb(100, 116, 139)' }}
            />
            <YAxis 
              stroke="rgb(100, 116, 139)" 
              style={{ fontSize: '12px' }}
              tick={{ fill: 'rgb(100, 116, 139)' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
              iconType="circle"
            />
            <Area 
              type="monotone" 
              dataKey="visitors" 
              stroke="rgb(37, 99, 235)" 
              strokeWidth={2}
              fill="url(#colorVisitors)" 
              name="Visitors"
            />
            <Area 
              type="monotone" 
              dataKey="pageViews" 
              stroke="rgb(245, 158, 11)" 
              strokeWidth={2}
              fill="url(#colorPageViews)" 
              name="Page Views"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AnalyticsOverviewChart;